module.exports = __webpack_public_path__ + "media/images/sp/brands/aqua/store_shinjuku-8519a1ea032e8a3da74066432c308370.jpg";